import { api } from "./api";

export type DividendSource = "YAHOO_ANNOUNCED" | "EXTRAPOLATED" | "MANUAL";
export type DividendKind = "FORECAST" | "PAST";
export type DividendConfidence = "high" | "medium" | "low";
export type InvestmentKind =
  | "AKTIE"
  | "ETF"
  | "KRYPTO"
  | "P2P"
  | "BETEILIGUNG"
  | "ANLEIHE"
  | "ROHSTOFFE"
  | "SONSTIGE";

export interface CalendarEntry {
  id: string;
  investmentId: string;
  investmentName: string;
  symbol: string;
  exDate?: string;
  payDate: string;
  amountPerShareCents?: number;
  currency?: string;
  currentShares?: number;
  sharesAtPayDate?: number;
  estimatedTotalCents?: number;
  estimatedTotalEur?: number;
  actualTotalCents?: number;
  actualTotalEur?: number;
  kind: DividendKind;
  investmentKind?: InvestmentKind;
  source?: DividendSource;
  confidence?: DividendConfidence;
}

export interface MonthlyTotal {
  month: string; // YYYY-MM
  totalEur: number;
  forecastEur: number;
  pastEur: number;
}

export interface DividendCalendar {
  monthlyTotals: MonthlyTotal[];
  entries: CalendarEntry[];
}

export interface ManualEntryInput {
  investmentId: string;
  exDate: string;
  payDate: string;
  amountPerShareCents: number;
  currency: string;
}

export interface RefreshResult {
  processed: number;
  succeeded: number;
  failed: number;
}

export const dividendsApi = {
  getCalendar(filters: { from?: string; to?: string }): Promise<DividendCalendar> {
    const params = new URLSearchParams();
    if (filters.from) params.set("from", filters.from);
    if (filters.to) params.set("to", filters.to);
    const qs = params.toString();
    return api<DividendCalendar>(`/dividends/calendar${qs ? `?${qs}` : ""}`);
  },
  refresh(): Promise<RefreshResult> {
    return api<RefreshResult>("/dividends/refresh", { method: "POST" });
  },
  createManual(input: ManualEntryInput): Promise<CalendarEntry> {
    return api<CalendarEntry>("/dividends/calendar", { method: "POST", body: input });
  },
  deleteManual(id: string): Promise<void> {
    return api<void>(`/dividends/calendar/${id}`, { method: "DELETE" });
  },
};
